// extracted by mini-css-extract-plugin
module.exports = {"commonLoader":"loader_commonLoader__1wCjW","loader":"loader_loader__1eJ2F","inlineLoader":"loader_inlineLoader__2OdjF"};